import { render, staticRenderFns } from "./AboutLinesMobile.vue?vue&type=template&id=52fed9fc&"
import script from "./AboutLinesMobile.vue?vue&type=script&lang=js&"
export * from "./AboutLinesMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports